export default {
  badge: 'Test',
  badge_title: 'Testrestaurant',
  notice: 'Dette er en testrestaurant. Bestillinger afgivet her er kun til test.',
};
